import React from 'react';
import './PinSearchNavBar.less';

const PinSearchTopBar: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => (
  <div className="pin-search-bar top-bar">{children}</div>
);

export default PinSearchTopBar;
